// extracted by mini-css-extract-plugin
export var bodyRow = "_cx-d";
export var cardColumns = "_cx-e";
export var ellipsesOverflow = "_cx-2";
export var flatBottomCorners = "_cx-3";
export var flatTopCorners = "_cx-4";
export var headerActionsDropdown = "_cx-f";
export var headerBottomRow = "_cx-c";
export var headerTopRow = "_cx-b";
export var orderDetailsWrapper = "_cx-0";
export var orderInfoContainer = "_cx-1";
export var productDetails = "_cx-9";
export var productImage = "_cx-5";
export var responsiveTable = "_cx-8";
export var shipmentContainer = "_cx-a";
export var tableBottomLeft = "_cx-6";
export var tableBottomRight = "_cx-7";
export var trackingLink = "_cx-g";